/**
 * Marketing Price Utilities
 * Calculates inflated "original" price for visual marketing display.
 * The real price shown to the user remains the host's actual basePrice/hourPrice.
 */

/**
 * Get the inflated "original" price for display as struck-through.
 * @param {number} realPrice - The actual price (basePrice or hourPrice)
 * @param {number} markupPercent - Markup percentage (e.g. 30 = 30%)
 * @returns {number} Inflated price rounded up
 */
export function getInflatedPrice(realPrice, markupPercent) {
    if (!realPrice || realPrice <= 0 || !markupPercent || markupPercent <= 0) return 0;
    return Math.ceil(realPrice * (1 + markupPercent / 100));
}

/**
 * Check if marketing pricing is enabled from siteSettings data.
 * @param {object} siteSettingsData - Redux state.siteSettings.data
 * @returns {{ enabled: boolean, markup: number }}
 */
export function getMarketingConfig(siteSettingsData) {
    if (!siteSettingsData) return { enabled: false, markup: 0 };

    const enabled = siteSettingsData.marketingPriceEnabled === 'true';
    const markup = parseInt(siteSettingsData.marketingPriceMarkup, 10) || 0;

    return { enabled: enabled && markup > 0, markup };
}
